import { ButtonNames, InputMode, } from "./common.model";
import { DataTableSchema, exportConfig } from "./dynamic-data-table.model";
import { ChartTypes, CommonChartModel } from "./chart.model";
import { SearchConfig } from "./api.model";
import { Subject } from "rxjs";
export const FIELD_TYPES = {
    DROPDOWN: "dropdown",
    TEXT: "text",
    TEXTSEARCH: "textsearch",
    NUMBER: "number",
    CHECKBOX: "checkbox",
    DATE: "date",
    EMAIL: "email",
    TEXTAREA: 'textarea',
    FILE: 'file'
}
export const INFO_TYPES = {
    Total: "total",
    Count: "count"
} as const;
export type InfoType = typeof INFO_TYPES[keyof typeof INFO_TYPES];
export type FieldType = typeof FIELD_TYPES[keyof typeof FIELD_TYPES];
export const DEFAULT_PROPS: Props = {
    isSearchVisible: true
}
export type FieldOption = {
    fieldLabel: any,
    fieldValue: any,
    displayTranformation?: any
}
export const DisplayTranformation = {
    none: "none",
    uppercase: "UPPERCASE"
}

export type fieldActionConfig = {
    icon: string,
    click?: any,
    resetClick?: any,
    resetEnabled?: boolean,
    resetVisible?: boolean,
    searchVisible?: boolean,
    triggerOnEnter?: boolean,
    triggerOnBlur?: boolean
}

export type DisplayTranformationType = typeof DisplayTranformation[keyof typeof DisplayTranformation];

export interface FormFieldConfig {
    fieldName: string,
    displayName: string,
    fieldInfo?: Array<string>
    fieldType: FieldType,
    isAutoComplete?: boolean,
    defaultValue: string | Array<any>,
    fileTypes?: any[],
    fieldActionConfig?: fieldActionConfig,
    restrictedFileTypes?: any[],
    options?: Array<FieldOption>,
    disabled: boolean,
    readonly?: boolean,
    required?: boolean,
    actionConfig?: any,
    selectedValue?: any,
    isDependentOn?: any,
    inputMode?: InputMode,
    inputType?: string,
    multiple?: boolean
    pattern?: any,
    displayTranformation?: DisplayTranformationType,
    min?: any,
    max?: any,
    isLoading?: boolean,
    showSelect?: boolean,
    payloadInfo?: any,
    preSelectedValues?: any,
    apiValues?: any,
    formName?: string,
    fieldCriteriaConfig?: any,
    camelCase?: boolean,
    hidden?: boolean,
    monthYearOnly?: boolean,
    isDefaultSet?: boolean
}

export interface InfoFieldConfig {
    fieldName: string,
    value: any,
    fieldLabel: string,
    calculateBy: any,
    style?: any,
    infoType: InfoType
}

export interface ButtonFieldConfig {
    isDisabled?: boolean;
    iconClass?: string,
    name: ButtonNames;
    actionCallback?: any;
    customEnableDisable?: boolean;
    buttonStyle?: any;
    detectChanges?: any;
    isPrimary?: boolean;
    isLoading?: boolean;
}
export interface FieldSelectedValue {
    FieldName: string;
    Value: any;
    FieldArray?: FormFieldConfig[];
}

export interface DynamicFormArray {
    FieldsArray: FormFieldConfig[],
    AdditionalForms?: {
        isEnabled: boolean,
        FieldsArray: FormFieldConfig[],
        onButtonClicked?: any,
        ButtonsArray: ButtonFieldConfig[],
        props: Props,
        title?: string,
        formName: string
    },
    ButtonsArray?: ButtonFieldConfig[],
    title?: string
    onControlValueChanged?: any,
    onButtonClicked?: any,
    searchConfig?: SearchConfig,
    multiSelectSearchConfig?: SearchConfig,
    globalPayloadSubject?: Subject<FieldSelectedValue>,
    globalTitleFields?: any
    resetAfterSubmit?: boolean,
    payload?: any,
    formName?: string,
    isCloseIcon?: boolean,
    autoSearchOnLoad?: boolean,
    alwaysEnableButtons?: boolean
    disableFieldsDuringLoad?: boolean
}

export const SECTION_TYPE = {
    FilterWithTable: 'filterWithTable',
    Dashboard: 'dashboard',
    GlobalFilter: 'globalFilter',
    List: 'list',
    Chart: 'chart',
    Filter: 'filter'
} as const

export type SectionType = typeof SECTION_TYPE[keyof (typeof SECTION_TYPE)]

export type filterInputSchema = {
    dynamicFormArray?: DynamicFormArray,
}
export type chartInputSchema = {
    chartSchema: CommonChartModel,
    chartType: ChartTypes,
    dynamicFormArray?: any,
    infoFields?: InfoFieldConfig[],
    exportConfig?: exportConfig,
    filterSchema?: DynamicFormArray,
    elementId: string,
    apiConfig: SearchConfig,
    globalFilterChangeCallback?: any
}
export type tableInputSchema = {
    DataTableSchema: DataTableSchema,
    dataInput: Array<any>,
    apiConfig: SearchConfig,
    infoFields?: InfoFieldConfig[],
    exportConfig?: exportConfig,
    filterSchema?: DynamicFormArray,
    globalFilterChangeCallback?: any
}

export type dynamicFilterSchema = {
    FieldsArray: FormFieldConfig[],
    onControlValueChanged: any
}
export type dynamicComponentSchema = {
    component: any,
    type: SectionType,
    inputs: any
}
export interface InputProperty {
    elementId?: any,
    filterSchema?: DynamicFormArray,
    DataTableSchema?: DataTableSchema,
    tableConfig?: DataTableSchema,
    dataInput?: Array<any>,
    dynamicFormArray?: DynamicFormArray,
    props?: Props,
    gridSchema?: Array<dynamicComponentSchema>,
    sectionInfo?: containerSectionInfo,
    sectionConfig?: Array<SectionConfig>
    apiConfig?: SearchConfig,
    title?: string,
    dataTransform?: (response: any) => Array<any>,
    options?: any,
    forSection?: boolean
}
export type containerSectionInfo = {
    actionInfo?: ButtonFieldConfig[],
    filterFieldsInfo?: DynamicFormArray,
    props: Props,
    isVisible?: boolean
}
export type SectionConfig = {
    infoFields?: InfoFieldConfig[],
    filterFields?: FormFieldConfig[],
    actionInfo?: ButtonFieldConfig[],
    chartInfo?: CommonChartModel,
    elementId: string,
    tableInfo?: DataTableSchema,
    sectionFilters?: DynamicFormArray,
    chartType?: ChartTypes,
    props?: Props,
    sectionType: SectionType,
    fetchDisplayData?: any,
    isVisible?: boolean,
    fetchCallBack?: any,
    exportMessage?: string
}
export type TabConfig = {
    label: string,
    component: any,
    searchKey?: string,
    inputs: InputProperty,
    tabId: any,
    type: SectionType,
    tabInfoText?: string,
    tabOnChangeSubject?: Subject<any>,
}

export interface TabGroupConfig {
    label: string;
    /** Sub-tabs rendered inside page-container (grouped mode) */
    tabs?: TabConfig[];
    /** Standalone mode: render this component directly with no sub-tab bar */
    component?: any;
    inputs?: Record<string, unknown>;
}

export interface Props {
    isSectionFilter?: boolean;
    tabConfig?: Array<TabConfig>,
    isrouterGap?: boolean,
    updatedOn?: Date,
    searchConfig?: SearchConfig
    isSearchVisible?: boolean,
    isTabStretch?: boolean,
    optionExplanation?: Array<any>,
    description?: Array<any>,
    filterSchema?: DynamicFormArray,
    infoFields?: Array<InfoFieldConfig>,
    istitleCenter?: boolean,
    showJobRoleContainer?: boolean,
    isBreadCrumbSection?: boolean,
    title?: string,
    subtitle?: string
}

export interface LayoutSearchConfig {
    searchConfig: SearchConfig,
    sectionInfo?: SectionConfig
}

export type selectCheckBoxValues = {
    FieldName: string, Value: { [key: string]: string[] | string }//, apiValues: string[]
}